import PropTypes from 'prop-types';

const CameraOffIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path
          d="M44.89 11.725c1.712-1.101 3.11-.195 3.11 2.02V33.29c0 2.207-1.402 3.112-3.11 2.01l-9.008-4.269v4.961c0 3.333-2.408 6.034-5.376 6.034H9.092L35.88 15.813v.182l9.01-4.27zm-6.06-6.222a1.72 1.72 0 0 1 0 2.432L4.27 42.496a1.72 1.72 0 0 1-2.433-2.432l34.56-34.561c.672-.67 1.76-.67 2.432 0zM30.505 5c.722 0 1.412.16 2.042.45L.108 37.197A6.775 6.775 0 0 1 0 35.992V11.033C0 7.701 2.406 5 5.376 5h25.13z"
          fill={fill}
          fillRule="nonzero"
        />
      </g>
    </svg>
  </div>
);

CameraOffIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

CameraOffIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default CameraOffIcon;
